module.exports = __webpack_public_path__ + "static/media/cover.bae9d865.png";